import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'

const endpoint = `${apiUrl.stable}/pesquisa`

export const getResearchQuestions = () => {
  const url = `${endpoint}`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

export const getResearchDisplay = () => {
  const url = `${endpoint}/exibir`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

export const postResearchAnswer = (answer) => {
  const url = `${endpoint}`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.post(url, answer, { headers })
}

export default {
  getResearchQuestions,
  getResearchDisplay,
  postResearchAnswer
}